<template>
  <aside class="profile-sidebar main-ui-fixed">
    <nav class="profile-nav" v-if="screenWidthFlag === 'desktop'">
      <ul class="profile-list">
        <li class="profile-list-item">
          <router-link
            :to="{ path: '/profile' }"
            exact
            class="profile-list-item-link"
            id="sidebar-my-profile"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Account</span>
          </router-link>
        </li>
        <li class="profile-list-item" v-if="!hideVerification">
          <router-link
            :to="{ path: '/profile/kyc' }"
            class="profile-list-item-link"
            id="sidebar-kyc"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Verification</span>
          </router-link>
        </li>
        <li class="profile-list-item" v-if="isCompany">
          <router-link
            :to="{ path: '/profile/associated-artists' }"
            tactive-class="active"
            class="profile-list-item-link"
            id="sidebar-associated_artists"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="23"
                height="22"
                viewBox="0 0 23 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.2913 3.49592C19.7805 2.98492 19.1741 2.57957 18.5066 2.303C17.8392 2.02644 17.1238 1.88409 16.4013 1.88409C15.6788 1.88409 14.9634 2.02644 14.2959 2.303C13.6285 2.57957 13.022 2.98492 12.5113 3.49592L11.4513 4.55592L10.3913 3.49592C9.3596 2.46423 7.96032 1.88463 6.50129 1.88463C5.04226 1.88463 3.64298 2.46423 2.61129 3.49592C1.5796 4.52761 1 5.92689 1 7.38592C1 8.84495 1.5796 10.2442 2.61129 11.2759L3.67129 12.3359L11.4513 20.1159L19.2313 12.3359L20.2913 11.2759C20.8023 10.7652 21.2076 10.1587 21.4842 9.49127C21.7608 8.82382 21.9031 8.10841 21.9031 7.38592C21.9031 6.66343 21.7608 5.94802 21.4842 5.28056C21.2076 4.61311 20.8023 4.00668 20.2913 3.49592V3.49592Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Associated artists</span>
          </router-link>
        </li>
        <li class="profile-list-item">
          <router-link
            :to="{ path: '/profile/my-songs' }"
            tactive-class="active"
            class="profile-list-item-link"
            id="sidebar-my-songs"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 18V5L21 3V16"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16C15 17.6569 16.3431 19 18 19Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>My Songs</span>
          </router-link>
        </li>
        <li class="profile-list-item" v-if="!hideInitialSale">
          <router-link
            to="/profile/ieos"
            class="profile-list-item-link"
            id="sidebar-ieos"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 1V23"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Initial Sale</span>
          </router-link>
        </li>
        <li class="profile-list-item" v-if="!hideInitialSaleHistory">
          <router-link
            to="/profile/initial-sale-history"
            class="profile-list-item-link"
            id="sidebar-initial-sale-history"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 6V12L16 14"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Initial Sale History</span>
          </router-link>
        </li>
        <li class="profile-list-item" v-if="!hideFavorites">
          <router-link
            :to="{ name: 'Favorite' }"
            class="profile-list-item-link"
            id="sidebar-favorite"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="23"
                height="22"
                viewBox="0 0 23 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.2913 3.49561C19.7805 2.98462 19.1741 2.57926 18.5066 2.3027C17.8392 2.02614 17.1238 1.88379 16.4013 1.88379C15.6788 1.88379 14.9634 2.02614 14.2959 2.3027C13.6285 2.57926 13.022 2.98462 12.5113 3.49561L11.4513 4.55561L10.3913 3.49561C9.3596 2.46392 7.96032 1.88432 6.50129 1.88432C5.04226 1.88432 3.64298 2.46392 2.61129 3.49561C1.5796 4.52731 1 5.92658 1 7.38561C1 8.84465 1.5796 10.2439 2.61129 11.2756L3.67129 12.3356L11.4513 20.1156L19.2313 12.3356L20.2913 11.2756C20.8023 10.7649 21.2076 10.1584 21.4842 9.49097C21.7608 8.82351 21.9031 8.1081 21.9031 7.38561C21.9031 6.66313 21.7608 5.94772 21.4842 5.28026C21.2076 4.6128 20.8023 4.00637 20.2913 3.49561V3.49561Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Favorites</span>
          </router-link>
        </li>
        <!--        <li class="profile-list-item">-->
        <!--          <router-link to="/profile/trading-history" class="profile-list-item-link"-->
        <!--                       :class="{active: setId === 'trading-history'}" id="sidebar-trading-history">-->
        <!--            <div class="profile-list-item-icon-wrap">-->
        <!--              <svg width="22" height="22" viewBox="0 0 22 22" fill="none"-->
        <!--                   xmlns="http://www.w3.org/2000/svg">-->
        <!--                <path fill-rule="evenodd" clip-rule="evenodd"-->
        <!--                      d="M10.6885 0C7.94837 0.00781631 5.31591 1.06769 3.33481 2.96071L3.3348 1.06885C3.3348 0.478539 2.85627 -2.38418e-07 2.26596 0C1.67565 0 1.19711 0.478539 1.19711 1.06885V5.87866C1.19711 6.46897 1.67565 6.94751 2.26596 6.94751H7.07577C7.66608 6.94751 8.14462 6.46897 8.14462 5.87866C8.14462 5.28835 7.66608 4.80981 7.07577 4.80981H4.51054C7.34531 1.84747 11.8838 1.31429 15.328 3.539C18.7721 5.76371 20.1523 10.12 18.6176 13.9222C17.083 17.7243 13.0654 19.9019 9.04198 19.1124C5.01853 18.3229 2.12179 14.7886 2.1377 10.6885C2.1377 10.0982 1.65916 9.61963 1.06885 9.61963C0.47854 9.61963 2.38419e-07 10.0982 0 10.6885C0 16.5916 4.78539 21.377 10.6885 21.377C16.5916 21.377 21.377 16.5916 21.377 10.6885C21.377 4.78539 16.5916 0 10.6885 0ZM10.6885 6.41309C10.0982 6.41309 9.61963 6.89163 9.61963 7.48193V10.6885C9.61963 11.2788 10.0982 11.7573 10.6885 11.7573H12.8262C13.4165 11.7573 13.895 11.2788 13.895 10.6885C13.895 10.0982 13.4165 9.61963 12.8262 9.61963H11.7573V7.48193C11.7573 6.89162 11.2788 6.41309 10.6885 6.41309Z"-->
        <!--                      fill="white"/>-->
        <!--              </svg>-->
        <!--            </div>-->
        <!--            <span>Trading History</span>-->
        <!--          </router-link>-->
        <!--        </li>-->
        <li class="profile-list-item">
          <router-link
            to="/profile/wallet"
            class="profile-list-item-link"
            id="sidebar-wallet"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 6.75H4.5C3.25736 6.75 2.25 7.75736 2.25 9V18C2.25 19.2426 3.25736 20.25 4.5 20.25H19.5C20.7426 20.25 21.75 19.2426 21.75 18V9C21.75 7.75736 20.7426 6.75 19.5 6.75Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M19.2825 6.74997V5.34373C19.2824 4.99882 19.2061 4.6582 19.0592 4.34615C18.9123 4.0341 18.6983 3.75832 18.4326 3.53849C18.1668 3.31866 17.8558 3.16019 17.5217 3.0744C17.1877 2.98861 16.8388 2.9776 16.5 3.04217L4.155 5.14919C3.6189 5.25136 3.13526 5.5374 2.78749 5.95799C2.43972 6.37858 2.24963 6.90735 2.25 7.4531V9.74997"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.25 15C16.9533 15 16.6633 14.912 16.4166 14.7472C16.17 14.5824 15.9777 14.3481 15.8642 14.074C15.7506 13.7999 15.7209 13.4983 15.7788 13.2074C15.8367 12.9164 15.9796 12.6491 16.1893 12.4393C16.3991 12.2296 16.6664 12.0867 16.9574 12.0288C17.2483 11.9709 17.5499 12.0006 17.824 12.1142C18.0981 12.2277 18.3324 12.42 18.4972 12.6666C18.662 12.9133 18.75 13.2033 18.75 13.5C18.75 13.8978 18.592 14.2794 18.3106 14.5607C18.0293 14.842 17.6478 15 17.25 15Z"
                  fill="white"
                />
              </svg>
            </div>
            <span>Wallet</span>
          </router-link>
        </li>
        <!--        <li class="profile-list-item">-->
        <!--          <router-link to="/profile/my-orders" class="profile-list-item-link" id="sidebar-my-orders">-->
        <!--            <div class="profile-list-item-icon-wrap">-->
        <!--              <svg width="23" height="29" viewBox="0 0 23 29" fill="none"-->
        <!--                   xmlns="http://www.w3.org/2000/svg">-->
        <!--                <g clip-path="url(#clip0)">-->
        <!--                  <path fill-rule="evenodd" clip-rule="evenodd"-->
        <!--                        d="M20.2273 -0.000976562H15.1476C13.9629 -0.000976562 12.999 0.962857 12.999 2.14756V7.22739C12.999 8.41209 13.9629 9.37592 15.1476 9.37592H20.2273C21.4121 9.37592 22.3759 8.41209 22.3759 7.22739V2.14756C22.376 0.962857 21.4121 -0.000976562 20.2273 -0.000976562ZM20.7314 7.22739C20.7314 7.50527 20.5053 7.73134 20.2274 7.73134H15.1476C14.8697 7.73134 14.6436 7.50527 14.6436 7.22739V2.14756C14.6436 1.86968 14.8697 1.6436 15.1476 1.6436H20.2274C20.5053 1.6436 20.7314 1.86968 20.7314 2.14756V7.22739Z"-->
        <!--                        fill="white"/>-->
        <!--                  <path fill-rule="evenodd" clip-rule="evenodd"-->
        <!--                        d="M16.2924 11.4288C15.8979 11.4288 15.5259 11.5267 15.1993 11.6996C14.7786 11.0692 14.0609 10.6533 13.2479 10.6533C12.828 10.6533 12.4335 10.7642 12.0922 10.9583C11.665 10.3782 10.9773 10.0011 10.2032 10.0011C9.95963 10.0011 9.7244 10.0385 9.50325 10.1078V9.37587H9.69858C10.8833 9.37587 11.8471 8.41203 11.8471 7.22733V2.14756C11.8471 0.962857 10.8833 -0.000976562 9.69858 -0.000976562H4.6188C3.4341 -0.000976562 2.47027 0.962857 2.47027 2.14756V7.22739C2.47027 8.41209 3.4341 9.37592 4.6188 9.37592H4.81412V14.4698C4.68699 14.3423 4.54419 14.2287 4.38741 14.1313C3.8823 13.8175 3.28998 13.7083 2.70917 13.8202C2.08466 13.8452 1.52419 14.1178 1.16014 14.5767C0.777719 15.0587 0.644891 15.705 0.795591 16.35L1.87619 20.9746C2.49258 24.8332 5.50248 27.7201 5.63065 27.8414C5.78338 27.9859 5.98566 28.0665 6.19595 28.0665H15.4446C15.7215 28.0665 15.9797 27.9272 16.1317 27.6959C17.7698 25.2042 18.6359 22.3111 18.6363 19.3295L18.6371 13.7734C18.6371 13.7734 18.6371 13.7734 18.6371 13.7733C18.637 12.4806 17.5852 11.4288 16.2924 11.4288ZM6.54142 26.4219C5.87871 25.717 3.92572 23.4407 3.49604 20.6898C3.49286 20.6696 3.48897 20.6495 3.48431 20.6296L2.39692 15.9758C2.36062 15.8203 2.37888 15.6865 2.44839 15.5988C2.5179 15.5111 2.63681 15.4654 2.79573 15.4502C2.87571 15.4426 2.90888 15.4331 2.98282 15.4286C3.16937 15.4173 3.36064 15.4297 3.51951 15.5284C3.67837 15.627 3.78922 15.7816 3.83176 15.9637L4.76967 19.9779C4.848 20.3131 5.12676 20.5641 5.46828 20.6068L5.53417 20.615C5.7683 20.6443 6.00359 20.5716 6.18044 20.4156C6.35729 20.2595 6.45854 20.0349 6.45854 19.7991V6.7304C6.45854 6.34442 6.7726 6.03035 7.15858 6.03035C7.54456 6.03035 7.85862 6.34442 7.85862 6.7304V12.3458V14.4413C7.85862 14.8954 8.22679 15.2636 8.68092 15.2636C9.13504 15.2636 9.50321 14.8954 9.50321 14.4413V12.3458C9.50321 11.9598 9.81721 11.6458 10.2032 11.6458C10.5892 11.6458 10.9032 11.9598 10.9032 12.3458V12.9979V14.5349C10.9032 14.989 11.2714 15.3572 11.7255 15.3572C12.1797 15.3572 12.5478 14.989 12.5478 14.5349V12.9979C12.5478 12.6119 12.8619 12.2979 13.2479 12.2979C13.6338 12.2979 13.9478 12.6119 13.9478 12.9979V13.7734V15.1091C13.9478 15.5633 14.316 15.9314 14.7701 15.9314C15.2243 15.9314 15.5924 15.5633 15.5924 15.1091V13.7734C15.5924 13.3874 15.9065 13.0733 16.2925 13.0733C16.6784 13.0733 16.9925 13.3874 16.9925 13.7732L16.9916 19.3293C16.9913 21.8425 16.3015 24.2853 14.9927 26.4219H6.54142V26.4219ZM4.11484 7.22739V2.14756C4.11484 1.86968 4.34092 1.6436 4.6188 1.6436H9.69858C9.97646 1.6436 10.2025 1.86968 10.2025 2.14756V7.22739C10.2025 7.50527 9.97646 7.73134 9.69858 7.73134H9.50325V6.73034C9.50325 5.43754 8.45144 4.38572 7.15863 4.38572C5.86583 4.38572 4.81401 5.43754 4.81401 6.73034V7.73134H4.61869C4.34092 7.73134 4.11484 7.50527 4.11484 7.22739Z"-->
        <!--                        fill="white"/>-->
        <!--                </g>-->

        <!--              </svg>-->
        <!--            </div>-->
        <!--            <span>My Orders</span>-->
        <!--          </router-link>-->
        <!--        </li>-->
        <li class="profile-list-item">
          <router-link
            to="/profile/invite"
            class="profile-list-item-link"
            id="sidebar-invite"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_7184_37441)">
                  <path
                    d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7184_37441">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span>Invites</span>
          </router-link>
        </li>
        <li class="profile-list-item">
          <router-link
            to="/profile/notifications"
            class="profile-list-item-link"
            id="sidebar-notifications"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13 1C15.1005 1 17.115 1.8351 18.6003 3.32159C20.0856 4.80808 20.92 6.82419 20.92 8.92641C20.92 17.7397 24.1323 19.4765 25 19.4765H1C1.88615 19.4765 5.08 17.7212 5.08 8.92641C5.08 6.82419 5.91443 4.80808 7.39971 3.32159C8.885 1.8351 10.8995 1 13 1V1Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.2307 22.8577C10.3903 23.4711 10.7487 24.0143 11.2499 24.402C11.751 24.7897 12.3665 25 12.9999 25C13.6334 25 14.2489 24.7897 14.75 24.402C15.2511 24.0143 15.6096 23.4711 15.7692 22.8577"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Notifications</span>
          </router-link>
        </li>
        <li class="profile-list-item" v-if="!hideAgreements">
          <router-link
            to="/profile/agreements"
            class="profile-list-item-link"
            id="sidebar-investor"
          >
            <div class="profile-list-item-icon-wrap">
              <div class="profile-list-icon-investor-border">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <span>Agreements</span>
          </router-link>
        </li>
        <li class="profile-list-item" v-if="!hideRoyalty">
          <router-link
            :to="{
              path: `/profile/royalty`,
              query: { paginationPage: 1, royaltyTab: 'contracts' },
            }"
            class="profile-list-item-link"
            id="sidebar-wallet"
          >
            <div class="profile-list-item-icon-wrap">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 17V22H22V17H2Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 2V17H22V2L17 8.25L12 2L7 8.25L2 2Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span>Royalty</span>
          </router-link>
        </li>

<!--        <li class="profile-list-item">-->
<!--          <router-link-->
<!--            to="/profile/offers"-->
<!--            class="profile-list-item-link"-->
<!--            id="sidebar-offers"-->
<!--          >-->
<!--            <div class="profile-list-item-icon-wrap">-->
<!--              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M2 19.0858V11.9142C2 11.0087 2.35971 10.1403 3 9.5C3.64029 8.85971 4.50871 8.5 5.41421 8.5H6.58579C7.49129 8.5 8.35971 8.85971 9 9.5C9.64029 10.1403 10.5087 10.5 11.4142 10.5H18.5858C19.4913 10.5 20.3597 10.8597 21 11.5C21.6403 12.1403 22 13.0087 22 13.9142V19.0858C22 19.9913 21.6403 20.8597 21 21.5C20.3597 22.1403 19.4913 22.5 18.5858 22.5H5.41421C4.50871 22.5 3.64029 22.1403 3 21.5C2.35971 20.8597 2 19.9913 2 19.0858Z" stroke="#FFFFFF" stroke-width="2"/>-->
<!--                <path d="M4 8.5V3.5C4 2.39543 4.89543 1.5 6 1.5H18C19.1046 1.5 20 2.39543 20 3.5V11" stroke="#FFFFFF" stroke-width="2"/>-->
<!--                <path d="M6 17.5H11" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/>-->
<!--              </svg>-->
<!--            </div>-->
<!--            <span>My Offers</span>-->
<!--          </router-link>-->
<!--        </li>-->

<!--        <li class="profile-list-item">-->
<!--          <router-link-->
<!--            to="/profile/nfts"-->
<!--            class="profile-list-item-link"-->
<!--            id="sidebar-nfts"-->
<!--          >-->
<!--            <div class="profile-list-item-icon-wrap">-->
<!--              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--                <path d="M10.5 1.86603C11.4282 1.33013 12.5718 1.33013 13.5 1.86603L20.0263 5.63397C20.9545 6.16987 21.5263 7.16025 21.5263 8.23205V15.7679C21.5263 16.8397 20.9545 17.8301 20.0263 18.366L13.5 22.134C12.5718 22.6699 11.4282 22.6699 10.5 22.134L3.97372 18.366C3.04552 17.8301 2.47372 16.8397 2.47372 15.7679V8.23205C2.47372 7.16025 3.04552 6.16987 3.97372 5.63397L10.5 1.86603Z" stroke="#FFFFFF" stroke-width="2"/>-->
<!--                <path d="M13 15.1429V7.34286L15 7" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                <path d="M11 17.1428C12.1046 17.1428 13 16.2474 13 15.1428C13 14.0383 12.1046 13.1428 11 13.1428C9.89543 13.1428 9 14.0383 9 15.1428C9 16.2474 9.89543 17.1428 11 17.1428Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--              </svg>-->
<!--            </div>-->
<!--            <span>My NFTs</span>-->
<!--          </router-link>-->
<!--        </li>-->

<!--        <li class="profile-list-item">-->
<!--          <router-link-->
<!--            to="/profile/licenses"-->
<!--            class="profile-list-item-link"-->
<!--            id="sidebar-licenses"-->
<!--          >-->
<!--            <div class="profile-list-item-icon-wrap">-->
<!--              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--                <path d="M22 11.0801V12.0001C21.9988 14.1565 21.3005 16.2548 20.0093 17.9819C18.7182 19.7091 16.9033 20.9726 14.8354 21.584C12.7674 22.1954 10.5573 22.122 8.53447 21.3747C6.51168 20.6274 4.78465 19.2462 3.61096 17.4372C2.43727 15.6281 1.87979 13.4882 2.02168 11.3364C2.16356 9.18467 2.99721 7.13643 4.39828 5.49718C5.79935 3.85793 7.69279 2.71549 9.79619 2.24025C11.8996 1.76502 14.1003 1.98245 16.07 2.86011" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                <path d="M22 4L12 14.01L9 11.01" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--              </svg>-->
<!--            </div>-->
<!--            <span>My Licenses</span>-->
<!--          </router-link>-->
<!--        </li>-->
        <!--        <li class="profile-list-item" v-if="user.userType === 'SERVICE_PROVIDER'">-->
        <!--          <router-link to="/profile/provider" class="profile-list-item-link" id="sidebar-provider">-->
        <!--            <div class="profile-list-item-icon-wrap">-->
        <!--              <svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--                <path d="M16 6.75C16.4142 6.75 16.75 6.41421 16.75 6C16.75 5.58579 16.4142 5.25 16 5.25V6.75ZM9 5.25C8.58579 5.25 8.25 5.58579 8.25 6C8.25 6.41421 8.58579 6.75 9 6.75V5.25ZM16 5.25L9 5.25V6.75L16 6.75V5.25Z" fill="white"/>-->
        <!--                <path d="M6 5.25C6.41421 5.25 6.75 5.58579 6.75 6C6.75 6.41421 6.41421 6.75 6 6.75L6 5.25ZM5 6.75C4.58579 6.75 4.25 6.41421 4.25 6C4.25 5.58579 4.58579 5.25 5 5.25L5 6.75ZM6 6.75L5 6.75L5 5.25L6 5.25L6 6.75Z" fill="white"/>-->
        <!--                <path d="M16 10.5C16.4142 10.5 16.75 10.1642 16.75 9.75C16.75 9.33579 16.4142 9 16 9V10.5ZM9 9C8.58579 9 8.25 9.33579 8.25 9.75C8.25 10.1642 8.58579 10.5 9 10.5V9ZM16 9L9 9V10.5L16 10.5V9Z" fill="white"/>-->
        <!--                <path d="M6 9C6.41421 9 6.75 9.33579 6.75 9.75C6.75 10.1642 6.41421 10.5 6 10.5L6 9ZM5 10.5C4.58579 10.5 4.25 10.1642 4.25 9.75C4.25 9.33579 4.58579 9 5 9L5 10.5ZM6 10.5L5 10.5L5 9L6 9L6 10.5Z" fill="white"/>-->
        <!--                <path d="M16 14.25C16.4142 14.25 16.75 13.9142 16.75 13.5C16.75 13.0858 16.4142 12.75 16 12.75V14.25ZM9 12.75C8.58579 12.75 8.25 13.0858 8.25 13.5C8.25 13.9142 8.58579 14.25 9 14.25V12.75ZM16 12.75L9 12.75V14.25L16 14.25V12.75Z" fill="white"/>-->
        <!--                <path d="M6 12.75C6.41421 12.75 6.75 13.0858 6.75 13.5C6.75 13.9142 6.41421 14.25 6 14.25L6 12.75ZM5 14.25C4.58579 14.25 4.25 13.9142 4.25 13.5C4.25 13.0858 4.58579 12.75 5 12.75L5 14.25ZM6 14.25L5 14.25L5 12.75L6 12.75L6 14.25Z" fill="white"/>-->
        <!--                <path d="M16 18C16.4142 18 16.75 17.6642 16.75 17.25C16.75 16.8358 16.4142 16.5 16 16.5V18ZM9 16.5C8.58579 16.5 8.25 16.8358 8.25 17.25C8.25 17.6642 8.58579 18 9 18V16.5ZM16 16.5H9V18H16V16.5Z" fill="white"/>-->
        <!--                <path d="M6 16.5C6.41421 16.5 6.75 16.8358 6.75 17.25C6.75 17.6642 6.41421 18 6 18L6 16.5ZM5 18C4.58579 18 4.25 17.6642 4.25 17.25C4.25 16.8358 4.58579 16.5 5 16.5L5 18ZM6 18L5 18L5 16.5L6 16.5L6 18Z" fill="white"/>-->
        <!--                <rect x="1.15" y="1.15" width="18.7" height="20.7" rx="3.85" stroke="white" stroke-width="1.7"/>-->
        <!--              </svg>-->
        <!--            </div>-->
        <!--            <span>Provider</span>-->
        <!--          </router-link>-->
        <!--        </li>-->
      </ul>
    </nav>

    <!--    sidebar for mobile devices -->

    <nav class="profile-nav" v-if="screenWidthFlag === 'mobile'">
      <vuescroll :ops="ops">
        <ul class="profile-list" ref="parentOfLinksRef">
          <li class="profile-list-item" @click="setCurrentTab">
            <router-link
              :to="{ path: '/profile' }"
              exact
              class="profile-list-item-link"
              id="sidebar-my-profile__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Account</span>
            </router-link>
          </li>
          <li
            v-if="!hideVerification"
            class="profile-list-item"
            @click="setCurrentTab"
          >
            <router-link
              :to="{ path: '/profile/kyc' }"
              class="profile-list-item-link"
              id="sidebar-kyc__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Verification</span>
            </router-link>
          </li>
          <li v-if="isCompany" class="profile-list-item">
            <router-link
              :to="{ path: '/profile/associated-artists' }"
              tactive-class="active"
              class="profile-list-item-link"
              id="sidebar-associated_artists__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.2913 3.49592C19.7805 2.98492 19.1741 2.57957 18.5066 2.303C17.8392 2.02644 17.1238 1.88409 16.4013 1.88409C15.6788 1.88409 14.9634 2.02644 14.2959 2.303C13.6285 2.57957 13.022 2.98492 12.5113 3.49592L11.4513 4.55592L10.3913 3.49592C9.3596 2.46423 7.96032 1.88463 6.50129 1.88463C5.04226 1.88463 3.64298 2.46423 2.61129 3.49592C1.5796 4.52761 1 5.92689 1 7.38592C1 8.84495 1.5796 10.2442 2.61129 11.2759L3.67129 12.3359L11.4513 20.1159L19.2313 12.3359L20.2913 11.2759C20.8023 10.7652 21.2076 10.1587 21.4842 9.49127C21.7608 8.82382 21.9031 8.10841 21.9031 7.38592C21.9031 6.66343 21.7608 5.94802 21.4842 5.28056C21.2076 4.61311 20.8023 4.00668 20.2913 3.49592V3.49592Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Associated artists</span>
            </router-link>
          </li>
          <li class="profile-list-item" @click="setCurrentTab">
            <router-link
              :to="{ path: '/profile/my-songs' }"
              tactive-class="active"
              class="profile-list-item-link"
              id="sidebar-my-songs__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 18V5L21 3V16"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16C15 17.6569 16.3431 19 18 19Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>My Songs</span>
            </router-link>
          </li>
          <li
            v-if="!hideInitialSale"
            class="profile-list-item"
            @click="setCurrentTab"
          >
            <router-link
              to="/profile/ieos"
              class="profile-list-item-link"
              id="sidebar-ieos__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 1V23"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Initial Sale</span>
            </router-link>
          </li>
          <li
            v-if="!hideInitialSaleHistory"
            class="profile-list-item"
            @click="setCurrentTab"
          >
            <router-link
              to="/profile/initial-sale-history"
              class="profile-list-item-link"
              id="sidebar-initial-sale-history__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 6V12L16 14"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Initial Sale History</span>
            </router-link>
          </li>
          <li
            v-if="!hideFavorites"
            class="profile-list-item"
            @click="setCurrentTab"
          >
            <router-link
              :to="{ name: 'Favorite' }"
              class="profile-list-item-link"
              id="sidebar-favorite__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.2913 3.49561C19.7805 2.98462 19.1741 2.57926 18.5066 2.3027C17.8392 2.02614 17.1238 1.88379 16.4013 1.88379C15.6788 1.88379 14.9634 2.02614 14.2959 2.3027C13.6285 2.57926 13.022 2.98462 12.5113 3.49561L11.4513 4.55561L10.3913 3.49561C9.3596 2.46392 7.96032 1.88432 6.50129 1.88432C5.04226 1.88432 3.64298 2.46392 2.61129 3.49561C1.5796 4.52731 1 5.92658 1 7.38561C1 8.84465 1.5796 10.2439 2.61129 11.2756L3.67129 12.3356L11.4513 20.1156L19.2313 12.3356L20.2913 11.2756C20.8023 10.7649 21.2076 10.1584 21.4842 9.49097C21.7608 8.82351 21.9031 8.1081 21.9031 7.38561C21.9031 6.66313 21.7608 5.94772 21.4842 5.28026C21.2076 4.6128 20.8023 4.00637 20.2913 3.49561V3.49561Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Favorites</span>
            </router-link>
          </li>
          <li class="profile-list-item" @click="setCurrentTab">
            <router-link
              to="/profile/wallet"
              class="profile-list-item-link"
              id="sidebar-wallet__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5 6.75H4.5C3.25736 6.75 2.25 7.75736 2.25 9V18C2.25 19.2426 3.25736 20.25 4.5 20.25H19.5C20.7426 20.25 21.75 19.2426 21.75 18V9C21.75 7.75736 20.7426 6.75 19.5 6.75Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.2825 6.74997V5.34373C19.2824 4.99882 19.2061 4.6582 19.0592 4.34615C18.9123 4.0341 18.6983 3.75832 18.4326 3.53849C18.1668 3.31866 17.8558 3.16019 17.5217 3.0744C17.1877 2.98861 16.8388 2.9776 16.5 3.04217L4.155 5.14919C3.6189 5.25136 3.13526 5.5374 2.78749 5.95799C2.43972 6.37858 2.24963 6.90735 2.25 7.4531V9.74997"
                    stroke="white"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.25 15C16.9533 15 16.6633 14.912 16.4166 14.7472C16.17 14.5824 15.9777 14.3481 15.8642 14.074C15.7506 13.7999 15.7209 13.4983 15.7788 13.2074C15.8367 12.9164 15.9796 12.6491 16.1893 12.4393C16.3991 12.2296 16.6664 12.0867 16.9574 12.0288C17.2483 11.9709 17.5499 12.0006 17.824 12.1142C18.0981 12.2277 18.3324 12.42 18.4972 12.6666C18.662 12.9133 18.75 13.2033 18.75 13.5C18.75 13.8978 18.592 14.2794 18.3106 14.5607C18.0293 14.842 17.6478 15 17.25 15Z"
                    fill="white"
                  />
                </svg>
              </div>
              <span>Wallet</span>
            </router-link>
          </li>
          <li class="profile-list-item" @click="setCurrentTab">
            <router-link
              to="/profile/invite"
              class="profile-list-item-link"
              id="sidebar-invite__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_7184_37441)">
                    <path
                      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_7184_37441">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span>Invites</span>
            </router-link>
          </li>
          <li class="profile-list-item" @click="setCurrentTab">
            <router-link
              to="/profile/notifications"
              class="profile-list-item-link"
              id="sidebar-notifications__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1C15.1005 1 17.115 1.8351 18.6003 3.32159C20.0856 4.80808 20.92 6.82419 20.92 8.92641C20.92 17.7397 24.1323 19.4765 25 19.4765H1C1.88615 19.4765 5.08 17.7212 5.08 8.92641C5.08 6.82419 5.91443 4.80808 7.39971 3.32159C8.885 1.8351 10.8995 1 13 1V1Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.2307 22.8577C10.3903 23.4711 10.7487 24.0143 11.2499 24.402C11.751 24.7897 12.3665 25 12.9999 25C13.6334 25 14.2489 24.7897 14.75 24.402C15.2511 24.0143 15.6096 23.4711 15.7692 22.8577"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Notifications</span>
            </router-link>
          </li>
          <li
            v-if="!hideAgreements"
            class="profile-list-item"
            @click="setCurrentTab"
          >
            <router-link
              to="/profile/agreements"
              class="profile-list-item-link"
              id="sidebar-investor__mobile"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Agreements</span>
            </router-link>
          </li>
          <li
            class="profile-list-item"
            @click="setCurrentTab"
            v-if="!hideRoyalty"
          >
            <router-link
              :to="{
                path: `/profile/royalty`,
                query: { paginationPage: 1, royaltyTab: 'contracts' },
              }"
              class="profile-list-item-link"
              id="sidebar-royalty"
            >
              <div class="profile-list-item-icon-wrap">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 17V22H22V17H2Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 2V17H22V2L17 8.25L12 2L7 8.25L2 2Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span>Royalty</span>
            </router-link>
          </li>

<!--          <li class="profile-list-item">-->
<!--          <router-link-->
<!--            to="/profile/offers"-->
<!--            class="profile-list-item-link"-->
<!--            id="sidebar-offers"-->
<!--          >-->
<!--            <div class="profile-list-item-icon-wrap">-->
<!--              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path d="M2 19.0858V11.9142C2 11.0087 2.35971 10.1403 3 9.5C3.64029 8.85971 4.50871 8.5 5.41421 8.5H6.58579C7.49129 8.5 8.35971 8.85971 9 9.5C9.64029 10.1403 10.5087 10.5 11.4142 10.5H18.5858C19.4913 10.5 20.3597 10.8597 21 11.5C21.6403 12.1403 22 13.0087 22 13.9142V19.0858C22 19.9913 21.6403 20.8597 21 21.5C20.3597 22.1403 19.4913 22.5 18.5858 22.5H5.41421C4.50871 22.5 3.64029 22.1403 3 21.5C2.35971 20.8597 2 19.9913 2 19.0858Z" stroke="#FFFFFF" stroke-width="2"/>-->
<!--                <path d="M4 8.5V3.5C4 2.39543 4.89543 1.5 6 1.5H18C19.1046 1.5 20 2.39543 20 3.5V11" stroke="#FFFFFF" stroke-width="2"/>-->
<!--                <path d="M6 17.5H11" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/>-->
<!--              </svg>-->
<!--            </div>-->
<!--            <span>My Offers</span>-->
<!--          </router-link>-->
<!--        </li>-->

<!--        <li class="profile-list-item">-->
<!--          <router-link-->
<!--            to="/profile/nfts"-->
<!--            class="profile-list-item-link"-->
<!--            id="sidebar-nfts"-->
<!--          >-->
<!--            <div class="profile-list-item-icon-wrap">-->
<!--              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">-->
<!--                <path d="M10.5 1.86603C11.4282 1.33013 12.5718 1.33013 13.5 1.86603L20.0263 5.63397C20.9545 6.16987 21.5263 7.16025 21.5263 8.23205V15.7679C21.5263 16.8397 20.9545 17.8301 20.0263 18.366L13.5 22.134C12.5718 22.6699 11.4282 22.6699 10.5 22.134L3.97372 18.366C3.04552 17.8301 2.47372 16.8397 2.47372 15.7679V8.23205C2.47372 7.16025 3.04552 6.16987 3.97372 5.63397L10.5 1.86603Z" stroke="#FFFFFF" stroke-width="2"/>-->
<!--                <path d="M13 15.1429V7.34286L15 7" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                <path d="M11 17.1428C12.1046 17.1428 13 16.2474 13 15.1428C13 14.0383 12.1046 13.1428 11 13.1428C9.89543 13.1428 9 14.0383 9 15.1428C9 16.2474 9.89543 17.1428 11 17.1428Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--              </svg>-->
<!--            </div>-->
<!--            <span>My NFTs</span>-->
<!--          </router-link>-->
<!--        </li>-->

        <li class="profile-list-item">
          <router-link
            to="/profile/licenses"
            class="profile-list-item-link"
            id="sidebar-licenses"
          >
            <div class="profile-list-item-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22 11.0801V12.0001C21.9988 14.1565 21.3005 16.2548 20.0093 17.9819C18.7182 19.7091 16.9033 20.9726 14.8354 21.584C12.7674 22.1954 10.5573 22.122 8.53447 21.3747C6.51168 20.6274 4.78465 19.2462 3.61096 17.4372C2.43727 15.6281 1.87979 13.4882 2.02168 11.3364C2.16356 9.18467 2.99721 7.13643 4.39828 5.49718C5.79935 3.85793 7.69279 2.71549 9.79619 2.24025C11.8996 1.76502 14.1003 1.98245 16.07 2.86011" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 4L12 14.01L9 11.01" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span>My Licenses</span>
          </router-link>
        </li>
        </ul>
      </vuescroll>
    </nav>
  </aside>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import vuescroll from "vuescroll";

export default {
  name: "Sidebar",
  data() {
    return {
      screenWidthFlag: "",
      currentTab: "",
      tabs: JSON.parse(localStorage.getItem("tabs")),
      user: JSON.parse(localStorage.getItem("user")),
      // setId: null,
      ops: {
        scrollPanel: {
          scrollingY: false,
        },
        bar: {
          opacity: 0,
        },
      },
    };
  },
  methods: {
    ...mapActions({
      setTabs: "userTabs/setTabs",
    }),
    lengthWatcher() {
      window.addEventListener(
        "resize",
        () => {
          if (window.innerWidth > 992) {
            this.screenWidthFlag = "desktop";
            return;
          }
          if (window.innerWidth <= 992) {
            this.screenWidthFlag = "mobile";
          }
        },
        false
      );
    },
    setCurrentTab(event) {
      let element = event.currentTarget.children[0];
      let elementId = element.id;
      document
        .getElementById(elementId)
        .scrollIntoView({ inline: "center", behavior: "auto" });
    },
  },
  computed: {
    ...mapGetters({
      money: "money/getMoney",
      // user: 'user/getUser',
      isLogged: "authentication/isLogged",
    }),
    hideInitialSale() {
      return this.tabs.isHideInitialSale;
    },
    hideInitialSaleHistory() {
      return this.tabs.isHideInitialSaleHistory;
    },
    hideAgreements() {
      return this.tabs.isHideAgreements;
    },
    hideFavorites() {
      return this.tabs.isHideFavorite;
    },
    hideRoyalty() {
      return this.tabs.isHideRoyalty;
    },
    hideVerification() {
      return this.tabs.kycTab.kycFlow === "NONE";
    },
    isCompany() {
      return (
        this.user.user_type !== "ARTIST" && this.user.user_type !== "INVESTOR"
      );
    },
  },
  mounted() {
    this.lengthWatcher();
    if (window.innerWidth > 992) {
      this.screenWidthFlag = "desktop";
    }
    if (window.innerWidth <= 992) {
      this.screenWidthFlag = "mobile";
    }

    this.setTabs();
  },
  components: {
    vuescroll,
  },
};
</script>

<style scoped>
</style>